import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../../app/AllowedMicroservices";
import { RootState } from "../../../app/store";
import apiActionCreator, {
  HttpMethods,
} from "../../../services/apiActionCreator";
import { FetchStatus } from "../../common/enums";
import { DataState, IReportValue, sortReportValue } from "../common";

const initialState: DataState = {
  data: [],
  status: FetchStatus.Idle,
};

export const dataSlice = createSlice({
  name: "knowledgeBaseByCategory",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<IReportValue[]>) => {
      state.data = action.payload;
      state.data.sort(sortReportValue);
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.data = [];
      state.status = FetchStatus.Error;
    },
  },
});

export const { fetching, fetched, error } = dataSlice.actions;

export const fetchKnowledgeBaseByCategory = (dispatch: Dispatch<object>) => {
  return dispatch(
    apiActionCreator({
      endpoint: "/content/report/byCategory",
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.GET,
      microservice: Microservices.KNOWLEDGE_BASE_SERVICE,
      authenticated: true,
    })
  );
};

export const selectKnowledgeBaseByCategoryData = (state: RootState) =>
  state.reports.knowledgeBase.byCategory.data;
export const selectKnowledgeBaseByCategoryIsFetching = (state: RootState) =>
  state.reports.knowledgeBase.byCategory.status === FetchStatus.Fetching;

export default dataSlice.reducer;
